import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { DrinksPupop } from "./DrinksPupop"
import { DrinkEntity } from "../../../Objects/MealsAndDrinks/DrinkEntity"
import { drinksMemory } from "../../../Objects/Memory/Memory"
import { useGetDrinks } from "../../../hooks/Drinks/useGetDrinks"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetCategory } from "../../../hooks/Category/useGetCategory"
import { useTranslation } from "react-i18next"
import { GenericFoodEntity } from "../../../Objects/MealsAndDrinks/GenericFoodEntity"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"
import { ProductQuickEditPopup } from "../../../components/QuickEditGrid/ProductQuickEditPopup"
import { faTableCells } from "@fortawesome/free-solid-svg-icons"
import { useQuickActionPopup } from "../../../hooks/useQuickActionPopup"

export const DrinksPage: React.FC = () => {
  const { t } = useTranslation("drink")

  const [enableDrinks, setEnableDrinks] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const [enableQuickEdit, setEnableQuickEdit] = useState(false)

  const { handleGetCategory } = useGetCategory()

  const { handleGetDrinks } = useGetDrinks()

  const [drink, setDrink] = useState<DrinkEntity | undefined>(undefined)

  const hasEditableDrinks = drinksMemory.getAll().length > 0

  useEffect(() => {
    const loadData = async () => {
      await handleGetCategory(async () => await handleGetDrinks(() => {}))
    }

    loadData()
  }, [])

  const handleOpenEditePromotion = (id: number) => {
    const promotion = drinksMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setDrink(promotion)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setDrink(undefined)

    setEnableDrinks(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  useQuickActionPopup("drinks-quick-edit", () => setEnableQuickEdit(true), hasEditableDrinks)

  const handleCopyDrink = () => {
    if (!drink) {
      return
    }

    setDrink(
      new DrinkEntity({
        ...drink,
        id: -1,
        genericFoodEntity: new GenericFoodEntity({
          ...drink.genericFoodEntity,
          id: -1,
          iconUrl: "",
        }),
      }),
    )
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          data={drinksMemory.getListCards(true)}
          messageCount={t("list:label_drinks_page_message_count")}
          messageEmpty={t("list:label_drinks_page_message_empty")}
          nameFindSearch={t("list:label_drinks_page_place_holder")}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleExtraFloatButton={hasEditableDrinks ? () => setEnableQuickEdit(true) : undefined}
          extraFloatButtonDescriptionKey="interactionDescriptions:components.list.list.button.handleQuickEditDrinks"
          extraFloatButtonIcon={faTableCells}
          extraFloatButtonColor="#f97316"
          handleRefreshButton={() => handleGetDrinks(() => {})}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
        />
      </div>

      {enableDrinks && (
        <DrinksPupop
          drink={drink}
          title={drink && drink.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyDrink}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="bebidas"
          title={t("dataImport:title", { target: t("dataImport:target_drinks") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetDrinks(() => {})}
        />
      )}

      {enableQuickEdit && hasEditableDrinks && (
        <ProductQuickEditPopup
          target="drink"
          products={drinksMemory.getAll()}
          onClose={() => setEnableQuickEdit(false)}
          onReload={async () => {
            await handleGetDrinks(() => {})
          }}
        />
      )}
    </>
  )
}
